<template>
  <div>
    <div class="loader-mw">
      <div class="background"></div>
      <!-- <div class="close" v-if="activeClose" @click="close">{{$t('dash.button.close')}}</div> -->
      <div class="loader">
        <div class="close-x" v-if="activeClose" @click="close"><img src="../../../assets/img/icon-delete.svg"/></div>
        <lottie-animation
          ref="anim"
          path="Loader_Mashup-Web.json"    
          :width="256"
          :height="256"
          :loop="true"
          :autoPlay="true"
        />
        <p v-if="!unlimitedProgress" class="progress">{{ progress }}%</p>
        <p v-if="detail" class="detail">{{ detail }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
  name: 'component-loader',

  components: {
    LottieAnimation
  },

  props: {
    progress: Number,
    unlimitedProgress: Boolean,
    activeClose: Boolean,
    detail: String
  },

  mounted() {
    // console.log('mount')
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
